import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class SharedService {

  readonly TREE_KEYS = 'treeData';
  readonly DATE_FORMAT = 'D/MM/YYYY';
  treeData: any = signal([]);
  username = signal<string | null>(null);
  private selectedNodes = signal<{ [key: string]: any }>({});
  private mapLocation = signal<any | []>([]);
  tableData = signal<any[]>([]);
  currentSelectedNode = signal<any | null>(null);

  readonly siteCoordinatesMap: Record<string, { lat: number; lng: number }> = {
    "MovieWorld": { lat: -27.903155, lng: 153.315003 },
    "Wet 'n Wild G.C.": { lat: -27.914518, lng: 153.318358 },
    "Sea World": { lat: -27.9559, lng: 153.4257 },
    "Wet 'n Wild Sydney": { lat: -33.807148, lng: 150.910480 }
  }

  private readonly userWiseTreeDisplayMetadata: { [username: string]: { [nodeId: string]: {name: string, rank: number, geo: {lat: number, lng: number}, image: string, details: any} } } = {
    gccc: {
      '69cb7444cfc0f4deb7c610bd': {
        name: 'MovieWorld',
        rank: 1, 
        geo: {lat: -27.903155, lng: 153.315003},
        image: '/assets/images/movieworldphoto.jpg', 
        details: {
          "SITE": 'MovieWorld Trade Waste Meter,\n Kopps Road, Oxenford, QLD\nAustralia',
          "MODEL": 'Siemens MAG5100',
          "SERIAL ID": '9875010194 / N1E5270213',
          "VERIFICATION DATE": '18 Nov. 2014',
        }
      },
      '69cb6a59ad0c413ed5c33d21': {
        name: 'Commercial Plaza',
        rank: 2, 
        geo: {lat: -28.0019054, lng: 153.4274871},
        image: '/assets/images/ecologger.jpg', 
        details: {
          "SITE": 'Commerical Plaza\nCavill Avenue, Surfers Paradise,\nQLD \nAustralia',
          "MODEL": 'Elster 100mm',
          "SERIAL ID": '',
          "VERIFICATION DATE": 'N/A',
        }
      },
    },
    cfe: {
      '69cb7444cfc0f4deb7c610bd': {
        name: 'MovieWorld',
        rank: 1, 
        geo: {lat: -27.90318, lng: 153.315},
        image: '/assets/images/movieworldphoto.jpg', 
        details: {
          "SITE": 'MovieWorld Trade Waste Meter,\n Kopps Road, Oxenford, QLD\n Australia',
          "MODEL": 'Siemens MAG5100',
          "SERIAL ID": '9875010194 / N1E5270213',
          "VERIFICATION DATE": '18 Nov. 2014',
        }},
      '69cb6a59ad0c413ed5c33d21': {
        name: 'Commercial Plaza',
        rank: 2, 
        geo: {lat: -28.0019054, lng: 153.4274871},
        image: '/assets/images/ecologger.jpg', 
        details: {
          "SITE": 'Commerical Plaza\nCavill Avenue, Surfers Paradise,\nQLD\nAustralia',
          "MODEL": 'Elster 100mm',
          "SERIAL ID": '',
          "VERIFICATION DATE": 'N/A',
        }},
    },
    master: {
      '69cb7444cfc0f4deb7c610bd': {
        name: 'Demo Sugar Mill',
        rank: 1, 
        geo: {lat: -21.426118, lng: 149.211794},
        image: '/assets/images/movieworldphoto.jpg',
        details: {
          "SITE": 'Mill Street, Proserpine, QLD\nAustralia',
          "MODEL": 'Siemens MAG5100',
          "SERIAL ID": 'XXXXXX',
          "VERIFICATION DATE": 'Unknown',
        }
      },
      '69cb6a59ad0c413ed5c33d21': {
        name: 'Commercial Plaza',
        rank: 2, 
        geo: {lat: -28.0019054, lng: 153.4274871},
        image: '/assets/images/ecologger.jpg', 
        details: {
          "SITE": 'Commerical Plaza\nCavill Avenue, Surfers Paradise,\nQLD\nAustralia',
          "MODEL": 'Elster 100mm',
          "SERIAL ID": '',
          "VERIFICATION DATE": 'N/A',
        }
      },
      '69cb7d7b018efd9ef171d1f1': {
        name: 'Manufacturing Co.',
        rank: 3, 
        geo: {lat: -27.8648825, lng: 153.333223},
        image: '/assets/images/ecologger.jpg', 
        details: {
          "SITE": 'Waterway Drive, Coomera, \nQLD \n Australia',
          "MODEL": 'ABB WaterMaster',
          "SERIAL ID": 'xxxxxx',
          "VERIFICATION DATE": '15 May 2014',
        }
      },
    },
    len: {
      '69cb7444cfc0f4deb7c610bd': {
        name: 'Demo Sugar Mill',
        rank: 1, 
        geo: {lat: -21.426118, lng: 149.211794},
        image: '/assets/images/movieworldphoto.jpg',
        details: {
          "SITE": 'Mill Street, Proserpine, QLD\n Australia',
          "MODEL": 'Siemens MAG5100',
          "SERIAL ID": 'XXXXXX',
          "VERIFICATION DATE": 'Unknown',
        }
      },
      '69cb6a59ad0c413ed5c33d21': {
        name: 'Commercial Plaza',
        rank: 2, 
        geo: {lat: -28.0019054, lng: 153.4274871},
        image: '/assets/images/ecologger.jpg', 
        details: {
          "SITE": 'Commerical Plaza\nCavill Avenue, Surfers Paradise,\nQLD\nAustralia',
          "MODEL": 'Elster 100mm',
          "SERIAL ID": '',
          "VERIFICATION DATE": 'N/A',
        }
      },
      '69cb7d7b018efd9ef171d1f1': {
        name: 'Manufacturing Co.',
        rank: 3, 
        geo: {lat: -27.8648825, lng: 153.333223},
        image: '/assets/images/photo_mains_01_cropped.jpg', 
        details: {
          "SITE": 'Waterway Drive, Coomera,\nQLD\nAustralia',
          "MODEL": 'ABB WaterMaster',
          "SERIAL ID": 'xxxxxx',
          "VERIFICATION DATE": '15 May 2014',
        }
      },
    },
    lw: {
      '69cb7444cfc0f4deb7c610bd': {
        name: 'Demo Sugar Mill',
        rank: 1, 
        geo: {lat: -21.426118, lng: 149.211794},
        image: '/assets/images/movieworldphoto.jpg',
        details: {
          "SITE": 'Mill Street, Proserpine, QLD\n Australia',
          "MODEL": 'Siemens MAG5100',
          "SERIAL ID": 'XXXXXX',
          "VERIFICATION DATE": 'Unknown',
        }
      },
      '69cb6a59ad0c413ed5c33d21': {
        name: 'Commercial Plaza',
        rank: 2, 
        geo: {lat: -28.0019054, lng: 153.4274871},
        image: '/assets/images/ecologger.jpg', 
        details: {
          "SITE": 'Commerical Plaza\nCavill Avenue, Surfers Paradise,\nQLD\nAustralia',
          "MODEL": 'Elster 100mm',
          "SERIAL ID": '',
          "VERIFICATION DATE": 'N/A',
        }
      },
      '69cb8bb1edffdba2cb009404': {
        name: 'Manufacturing Co.',
        rank: 3, 
        geo: {lat: -27.8648825, lng: 153.333223},
        image: '/assets/images/photo_mains_01_cropped.jpg', 
        details: {
          "SITE": 'Waterway Drive, Coomera,\nQLD\nAustralia',
          "MODEL": 'ABB WaterMaster',
          "SERIAL ID": 'xxxxxx',
          "VERIFICATION DATE": '15 May 2014',
        }
      },
    },
    quu: {
      '69cb6ecbf3c7c81d433d0325': {
        name: 'Churchill',
        rank: 1, 
        geo: {lat: -27.644019, lng: 152.748238},
        image: '/assets/images/churchillphoto.jpg',
        details: {
          "manufacturer": 'Siemens',
          "model": 'Sens. 7ME658 Trans. 7ME691',
          "serialId": 'Se. 9875010194 \n Tr. N1E5270213',
          "verificationDate": '18 November 2014',
        }
      },
      '69cb729c5cfe0f61e73bd535': {
        name: 'QUU',
        rank: 2, 
        geo: {lat: -27.454126, lng: 153.035139},
        image: '/assets/images/QUUphoto.jpg',
        details: {
          "manufacturer": 'Unknown',
          "model": 'Unknown',
          "serialId": 'Unknown',
          "verificationDate": 'Unknown',
        }
      },
    },
  };

  chartDateRange: { start: string; end: string } = {
    start: moment().format(this.DATE_FORMAT),
    end: moment().format(this.DATE_FORMAT),
  };

  constructor(){
    const savedUser = sessionStorage.getItem('username');
    if (savedUser) {
      this.username.set(savedUser);
    }
  }

  setUsername(name: string | null) {
    this.username.set(name);
  }

  getUsername(): string | null {
    return this.username();
  }

  setTreeData(data: any): void {
    this.treeData.set(data);
    sessionStorage.setItem(this.TREE_KEYS, JSON.stringify(data));
  }

  setCurrentSelectedNode(node: any) {
    this.currentSelectedNode.set(node);
  }

  setSelectedNode(routeKey: string, node: any) {
    this.selectedNodes.update(prev => ({
      ...prev,
      [routeKey]: node
    }));
  }

  getSelectedNode(key: string) {
    return this.selectedNodes()[key];
  }

  setMapLocation(location: any) {
    this.mapLocation.set(location);
  }

  getMapLocation(): any {
    return this.mapLocation();
  }

  setTableData(data: any[]) {
    this.tableData.set(data);
  }

  getUserWiseTreeDisplayMetadata(username: string, nodeId: string) {
    if (!username || !nodeId) {
      return null;
    }
    return this.userWiseTreeDisplayMetadata[username][nodeId];
  }

  getLoginUserTreeMeta() {
    const username = this.getUsername();
    if (!username) {
      return null;
    }
    return this.userWiseTreeDisplayMetadata[username];
  }
}
